import React, { useState, useEffect } from "react";
import "./custom.css"; // Custom CSS for styling
import DocumentationViewer from "../components/DocumentationViewer";
import { useNavigate, useParams } from "react-router-dom";
import { markdownPaths } from "../types/markdownPaths";

// Define the available sections as a union type for better typing
type Section = "releases-and-changes" | "release-process";

const KHReleasesPage: React.FC = () => {
  const navigate = useNavigate();
  const { section } = useParams<{ section: Section }>();
  const [selectedSection, setSelectedSection] = useState<Section>(
    "releases-and-changes"
  );

  // Update the selected section based on the URL parameter
  useEffect(() => {
    if (section) {
      setSelectedSection(section);
    }
  }, [section]);

  // Function to switch sections and update the URL
  const handleSectionChange = (section: Section) => {
    setSelectedSection(section);
    navigate(`/knowledge-hub/releases/${section}`);
  };

  return (
    <div className="api-concepts-page">
      {/* Horizontal Menu with Section Categories */}
      <nav className="api-concepts-menu bg-gray-100 p-4">
        <ul className="flex justify-center space-x-8">
          <li
            className={`cursor-pointer ${
              selectedSection === "releases-and-changes"
                ? "text-green-600 font-bold"
                : ""
            }`}
            onClick={() => handleSectionChange("releases-and-changes")}
          >
            Releases & Changes
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "release-process"
                ? "text-green-600 font-bold"
                : ""
            }`}
            onClick={() => handleSectionChange("release-process")}
          >
            Release Process
          </li>
        </ul>
      </nav>

      {/* Content Area */}
      <div className="content-area">
        {selectedSection === "releases-and-changes" && (
          <DocumentationViewer
            filePath={markdownPaths.KHReleasesURL}
            hideTableOnMobile={true}
          />
        )}
        {selectedSection === "release-process" && (
          <DocumentationViewer filePath={markdownPaths.KHReleaseProcessURL} />
        )}
      </div>
    </div>
  );
};

export default KHReleasesPage;
